import { render, staticRenderFns } from "./listaVinculos.vue?vue&type=template&id=41e26d86&scoped=true&"
import script from "./listaVinculos.vue?vue&type=script&lang=js&"
export * from "./listaVinculos.vue?vue&type=script&lang=js&"
import style0 from "./listaVinculos.vue?vue&type=style&index=0&id=41e26d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e26d86",
  null
  
)

export default component.exports